import React from 'react';

import { useTranslation } from '@gem/modules/i18n';

import { ICalendarAuthAccount } from 'APP/model/calendar/calendar.types';

import { EmailItem } from './EmailItem';
import styles from './ExternalEmails.styles.m.css';

interface IExternalEmailsProps {
  accounts: ICalendarAuthAccount[];
}

export const ExternalEmails: React.FC<IExternalEmailsProps> = ({ accounts }) => {
  const { t } = useTranslation();

  return (
    <div>
      <div className={styles.title}>{t('calendar_settings_external_calendar')}</div>
      {accounts.map((account) => (
        <EmailItem
          key={account.account.providerEmail}
          email={account.account.providerEmail}
          isActive={account.isActive}
        />
      ))}
    </div>
  );
};
